import { FETCH_INTERVENTION_SUCCESS } from 'modules/interventions/actionTypes';
import { CHANGE_INTERVENTION_STEP_SUCCESS } from 'modules/steps/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   stepId: string,
 *   userId: string,
 *   isUpdating: boolean,
 *   userGroupId: string,
 * }} InterventionUIDetailsStepReducer
 */

const initialState = {
  stepId: null,
  userId: null,
  isUpdating: false,
  userGroupId: null,
};

const onStepChange = (state, { payload }) => ({
  ...state,
  stepId: payload.step?.id,
  userId: payload.assignedUser?.id ?? null,
  userGroupId: payload.assignedUserGroup?.id ?? null,
});

export default createReducer(initialState, {
  [FETCH_INTERVENTION_SUCCESS]: onStepChange,
  [CHANGE_INTERVENTION_STEP_SUCCESS]: onStepChange,
});
